/* src/app/forms/produtos/shopee/shopee-attribute/shopee-attribute-field/shopee-attribute-field.component.scss */
.full {
  width: 100%;
}
.attr-children {
  margin: 8px 0 0 12px;
  padding-left: 12px;
  border-left: 3px solid #ddd;
}
.attr-children__title {
  font-size: 12px;
  font-weight: 500;
  color: #888;
  text-transform: uppercase;
  margin-bottom: 8px;
}
.multi-field {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}
.multi-field .full {
  flex: 1;
}
.multi-field .unit {
  width: 100px;
  flex: none;
}
/*# sourceMappingURL=shopee-attribute-field.component.css.map */
